import { tv, type VariantProps } from "tailwind-variants";

export const colorVariationCarouselVariant = tv({
  slots: {
    base: ["w-full", "py-4"],
    container: ["container-fluid"],
    wrapper: ["flex", "flex-col", "gap-6", "pb-8", "section-border"],
    header: ["flex", "flex-col", "gap-3", "w-full"],
    swiper: ["w-full"],
    image: ["w-full", "object-cover", "rounded-2xl", "overflow-hidden"],
    thumbs: [
      "w-full",
      "[&_.swiper-wrapper]:justify-center mt-6",
      "[&_.swiper-slide-thumb-active>span]:outline-1",
    ],
    thumbSlide: [
      "flex",
      "items-center",
      "justify-center",
      "w-6",
      "h-6",
      "rounded-full",
      "border-2",
      "border-solid",
      "border-white",
      "dark:border-black",
      "outline-0",
      "indent-[-9999px]",
      "cursor-pointer",
    ],
  },
  variants: {},
  defaultVariants: {},
});

export type ColorVariationCarouselVariantProps = VariantProps<
  typeof colorVariationCarouselVariant
>;
export type ColorVariationCarouselReturnVariantProps = ReturnType<
  typeof colorVariationCarouselVariant
>;
